import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {contentFeedsApi} from '../../../contentFeeds.api';
import {RemoteAiContentBrief} from 'common/src/modules/contentFeeds/contentFeeds.aiContentTypes';
import {setFeed} from '../reducers/contentFeedPageBase.slice';

export const updateFeedBrief = createAsyncThunk(
  `${BreadcrumbName.ContentFeedPage}/updateFeedBrief`,
  async ({feedId, brief}: {feedId: number; brief: RemoteAiContentBrief}, {dispatch}) => {
    await contentFeedsApi.updateBrief(feedId, brief);
    const feed = await contentFeedsApi.getFeed(feedId);
    dispatch(setFeed(feed));
  },
);
